import { updateKeyInStore } from 'App';
import { FamilyStateValues, TSpouseCitizenshipsRow, updateKey } from '../slice';

export const uploadFields: IBaseField<
  keyof FamilyStateValues | keyof TSpouseCitizenshipsRow
>[] = [
  {
    type: 'upload',
    name: 'GcCopy',
    label:
      'Please upload a scanned copy of the front of the green card showing the date of issuance',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.family.values.didSpouseRenounceGcDuringYear',
    predicate: (value) => value === 'yes',
  },
];
